export var ADMIN_ROUTER = {
    ADMIN: "/admin",
    ADMIN_AUDIO_GUIDES: "/audio-guides/admin",
    ADMIN_CHAT_CREATE: "/guides/admin/chats/create",
    ADMIN_CHAT_EDIT: "/guides/admin/chats/edit",
    ADMIN_GUIDES: "/guides/admin",
    ADMIN_GUIDES_CREATE: "/guides/admin/create",
    ADMIN_GUIDES_EDIT: "/guides/admin/edit",
};
